import { Component, OnInit } from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { ReservationModel } from "../../../models/reservations/reservation.model";
import { TranslateService } from "@ngx-translate/core";
import { ApprovedReservationsComponent } from "../approved-reservations/approved-reservations.component";
import { Subject, takeUntil } from "rxjs";
import { ReservationService } from "../../../services/reservations/reservation.service";
import { GetReservationsByUserRequestModel } from "../../../models/reservations/get-reservations-by-user-request.model";
import { ReservationStatusEnum } from "../../../enums/reservation-status.enum";
import { VenueService } from "../../../services/venues/venue.service";
import { VenueModel } from "../../../models/venues/venue.model";
import { AddDeclineCommentDialogComponent } from "../add-decline-comment-dialog/add-decline-comment-dialog.component";
import * as moment from "moment/moment";

@Component({
  selector: 'app-reservation-details',
  templateUrl: './reservation-details.component.html',
  styleUrls: ['./reservation-details.component.scss']
})
export class ReservationDetailsComponent implements OnInit {

  //#region Fields
  public unsubscribe: Subject<void> = new Subject<void>();
  public reservationDetails: ReservationModel = new ReservationModel();
  public id: string;
  public spinner: boolean = false;
  public reservationStatusEnum = ReservationStatusEnum;
  public showVenueName: boolean = false;
  public venueName: string;
  public pastList: boolean = false;
  public showMoreDetails: boolean = false;
  //#endregion

  //#region Constructor
  constructor(
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    private reservationService: ReservationService,
    private venueService: VenueService,
    public dialogService: DialogService,
    public translate: TranslateService
  ) {
    if (this.config.data != undefined && this.config.data.id) {
      this.id = this.config.data.id;
    }
    if (this.config.data != undefined && this.config.data.showVenueName) {
      this.showVenueName = this.config.data.showVenueName;
    }
    if (this.config.data != undefined && this.config.data.pastList) {
      this.pastList = this.config.data.pastList;
    }
  }

  public ngOnInit(): void {
    this.getReservationDetails();
  }
  //#endregion

  //#region Public Methods
  public getReservationDetails(): void {
    this.spinner = true;
    this.reservationService.getReservationDetails(this.id)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.reservationDetails = response;

          if (this.showVenueName) {
            this.getVenueName();
          } else {
            this.spinner = false;
          }
        },
        error: errorResponse => {
          this.spinner = false;
        }
      });
  }

  public approveOrDeclineReservation(approve: boolean): void {
    if (approve) {
      this.sendApproveOrDeclineRequest(approve);
      return;
    }

    let ref = this.dialogService.open(AddDeclineCommentDialogComponent, {
      width: '410px',
      styleClass: 'add-comment-dialog',
      closable: false,
      header: this.translate.instant('RESERVATION.DECLINE_QUESTION')
    });

    ref.onClose.subscribe((response: {decline: boolean, message: string}) => {
      if (!response.decline) {
        return;
      }
      if (response.message.trim().length > 0) {
        this.sendApproveOrDeclineRequest(approve, response.message);
      } else {
        this.sendApproveOrDeclineRequest(approve);
      }
    });
  }

  public sendApproveOrDeclineRequest(approve: boolean, declinedComment?: string): void {
    this.spinner = true;
    this.reservationService.approveOrDenyReservation(this.id, approve, declinedComment)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.spinner = false;
          this.ref.close(approve);
        },
        error: errorResponse => {
          this.spinner = false;
        }
      });
  }

  public openDetailsPopup(): void {
    let model = new GetReservationsByUserRequestModel();
    model.userEmail = this.reservationDetails.email;
    model.venueId = this.reservationDetails.venueId;
    this.dialogService.open(ApprovedReservationsComponent, {
      data: { model },
      header: this.translate.instant('RESERVATION.APPROVED_RESERVATIONS'),
      width: '985px'
    });
  }


  public getVenueName(): void {
    this.venueService.getvenuedetails(this.reservationDetails.venueId)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response: VenueModel) => {
          this.venueName = response.name;
          this.spinner = false;
        }
      });
  }

  public addToPriorityList(): void {
    this.spinner = true;
    this.reservationService.addToPriorityList(this.id)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.spinner = false;
          this.ref.close({priorityChanged: true});
        },
        error: errorResponse => {
          this.spinner = false;
        }
      });
  }
  //#endregion
}
